import React from 'react'
import ReactDOM from 'react-dom'
import eventBus from '../../../../../util/eventBus'
import "./style/style.less"

import APP from "./views/App.js"

(function (KDApi) {
  function MyComponent(model) {
    this._setModel(model)
  }

  // hsas_control_xbf

  MyComponent.prototype = {
    _setModel: function (model) {
      this.model = model
    },
    init: function (props) {
      // console.log('-----init', { props })
      setHtml(this.model, props)
    },
    update: function (props) {
      console.log('-----update', { props, model: this.model })
      eventBus.pub(this.model, 'update', props)
    },
    destoryed: function () {
      // console.log('-----destoryed', this.model)
      ReactDOM.unmountComponentAtNode(this.model.dom)
    }
  }

  var setHtml = function (model, primaryProps) {
    KDApi.loadFile('./css/index.css', model, () => {
      class Root extends React.Component {
        constructor(props) {
          super(props)

          this.state = {
            model: props.model,
            showDatePanel: false,
            formatSplit: "-",
            defaultDate: [],
            datePanelType: "1",
            dateRange: []
          }
        }

        componentDidMount() {
          const { model } = this.state
          this.updateSub = eventBus.sub(model, 'update', (updateProps) => {
            const data = updateProps?.data ?? null
            const { eventName = "", eventStatus = "" } = data
            if (eventStatus !== "update") return
            switch (eventName) {
              case "openDatePanel":
                const { customFormat = "YYYY", defaultDate = [], datePanelType = "1", dateRange = [] } = data?.data ?? {}
                this.setState({
                  ...this.state,
                  showDatePanel: true,
                  mateFormat: customFormat,
                  defaultDate,
                  datePanelType,
                  dateRange
                })
                break;
            }
          })
        }

        componentWillUnmount() {
          eventBus.unsub(this.updateSub)
        }

        updateShow = () => {
          const customFormat = "YYYY-MM-DD"
          const defaultDate = ["2021"]

          this.setState({
            showDatePanel: true,
            datePanelType: this.state.datePanelType === "1" ? "2" : "1", //1.仅年份 2.自定义
            mateFormat: customFormat,
            defaultDate,
          })
        }

        upState = (key, val) => {
          this.setState({ [key]: val })
        }

        I18N = key => KDApi.getLangMsg(model, key)

        render() {

          return (
            <div style={{ background: "#eee" }}>
              {/* <div onClick={() => { this.updateShow() }}>打开</div> */}
              <APP {...this.state} upState={this.upState} I18N={this.I18N} />
            </div>
          )
        }
      }

      ReactDOM.render(<Root model={model} customProps={primaryProps} />, model.dom)
    })
  }

  // 注册自定义组件
  KDApi.register('kddate2tab', MyComponent, { isMulLang: true })
})(window.KDApi)
